module.exports = __webpack_public_path__ + "static/media/not-available.6d4aa768.svg";